import { render } from "./ViewTicket.vue?vue&type=template&id=670ab540&scoped=true"
import script from "./ViewTicket.vue?vue&type=script&lang=js"
export * from "./ViewTicket.vue?vue&type=script&lang=js"

import "./ViewTicket.vue?vue&type=style&index=0&id=670ab540&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670ab540"]])

export default __exports__